/* eslint-disable no-console */
import axios from 'axios';
import localStorage from 'store2';
import set from 'lodash/set';

const LOCAL_STORAGE_KEY = 'jwt';
const LOCAL_STORAGE_TIMESTAMP_KEY = 'timestamp';
const jwtToken = localStorage.get(LOCAL_STORAGE_KEY);
const timestampHeaderValue = localStorage.get(LOCAL_STORAGE_TIMESTAMP_KEY);

axios.defaults.baseURL = 'https://cfnt-dev.azurewebsites.net/';
axios.defaults.withCredentials = false;

if (jwtToken) {
  axios.defaults.headers.Authorization = `Bearer ${jwtToken}`;
}

if (timestampHeaderValue) {
  axios.defaults.headers.Timestamp = `${timestampHeaderValue}`;
}

export const logError = error => {
  console.error(error);
  console.debug('axios request to API `error.response`', error.response);
  console.debug('axios request to API `error.request`', error.request);
  console.debug('axios request to API `error.config`', error.config);
};

export const setAuthHeader = token => {
  if (!token) {
    delete axios.defaults.headers.Authorization;
  } else {
    localStorage.set(LOCAL_STORAGE_KEY, token);

    set(axios, 'defaults.headers.Authorization', `Bearer ${token}`);
  }
};

export const setTimestampHeader = timestamp => {
  if (!timestamp) {
    delete axios.defaults.headers.Timestamp;
  } else {
    localStorage.set(LOCAL_STORAGE_TIMESTAMP_KEY, timestamp);

    set(axios, 'defaults.headers.Timestamp', `${timestamp}`);
  }
};

export const clearAuthHeader = () => {
  setAuthHeader(undefined);
  setTimestampHeader(undefined);
};

export default axios;
